/**
 * CommunicationSection.tsx
 * 連絡手段チップ: TEL, LINE, SMS, WhatsApp, Instagram, Other
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import { COMMUNICATION_MEDIA_COLORS } from '../../../constants/status';
import { FieldMarkWrap } from '../conflict/fieldState';

const COMM_FIELDS = ['communication_tools'] as const;

const COMMUNICATION_TOOLS = [
  { id: 1, name: 'TEL' },
  { id: 2, name: 'LINE' },
  { id: 3, name: 'SMS' },
  { id: 4, name: 'WhatsApp' },
  { id: 5, name: 'Instagram' },
  { id: 6, name: 'その他' },
] as const;

const NAME_TO_KEY: Record<string, keyof typeof COMMUNICATION_MEDIA_COLORS> = {
  TEL: 'TEL',
  LINE: 'LINE',
  SMS: 'SMS',
  WhatsApp: 'WhatsApp',
  Instagram: 'Instagram',
};

export default function CommunicationSection({
  data,
  onChange,
  disabled,
}: SectionProps) {
  const selected: number[] = Array.isArray(data.communication_tools)
    ? data.communication_tools
    : [];

  const handleToggle = (toolId: number) => {
    if (disabled) return;
    const isSelected = selected.includes(toolId);
    const updated = isSelected
      ? selected.filter((id) => id !== toolId)
      : [...selected, toolId].sort((a, b) => a - b);
    onChange?.({ communication_tools: updated });
  };

  return (
    <>
      <SectionHeader title="連絡手段" />
      <FieldMarkWrap fields={COMM_FIELDS} chip style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: '8px 4px', alignItems: 'center' }}>
        {COMMUNICATION_TOOLS.map((tool) => {
          const isActive = selected.includes(tool.id);
          const colorKey = NAME_TO_KEY[tool.name] || 'default';
          const colors = COMMUNICATION_MEDIA_COLORS[colorKey] || COMMUNICATION_MEDIA_COLORS.default;

          return (
            <button
              key={tool.id}
              type="button"
              onClick={() => handleToggle(tool.id)}
              style={{
                padding: '2px 8px',
                fontSize: '0.75rem',
                fontWeight: isActive ? 600 : 400,
                border: isActive ? `1px solid ${colors.bg_color}` : '1px solid #cbd5e1',
                borderRadius: 4,
                cursor: disabled ? 'default' : 'pointer',
                background: isActive ? colors.bg_color : '#e2e8f0',
                color: isActive ? colors.text_color : '#64748b',
                transition: 'all 0.15s',
              }}
            >
              {tool.name}
            </button>
          );
        })}
      </FieldMarkWrap>
    </>
  );
}
